import React from "react";
import { FiLogOut } from "react-icons/fi";
import userPic from "../assets/user.png";
import useAuth from "../useAuth";

export const ProfilePage = () => {
  const { user, logout } = useAuth();

  console.log(user);

  return (
    <div className="w-full mt-20 flex items-center justify-center py-10 px-4">
      <div className="w-full max-w-lg border bg-white rounded-2xl shadow-xl p-8">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <img
            src={user?.profilePhoto || userPic}
            alt="Profile"
            className="w-20 h-20 rounded-full border-4 border-blue-200 shadow-md object-cover"
          />
          <div>
            <h2 className="text-2xl font-bold text-blue-800">
              {user?.name || "User"}
            </h2>
            <p className="text-sm text-gray-500 uppercase">
              {user?.designation || "—"} | {user?.userType || "User"}
            </p>
          </div>
        </div>

        {/* Info Fields */}
        <div className="space-y-3 text-gray-700">
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">📧 Username:</span>
            <span>{user?.email || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">📞 Mobile:</span>
            <span>{user?.mobile || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">🆔 User Type:</span>
            <span className="uppercase">{user?.userType || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">✅ Verified:</span>
            <span>Yes</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">🕓 Registered At:</span>
            <span>
              {user?.createdAt
                ? new Date(user.createdAt).toLocaleString("en-IN")
                : "---"}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={logout}
            className="flex items-center gap-2 px-5 py-2 rounded-full text-white bg-red-500 hover:bg-red-600 transition shadow"
          >
            <FiLogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};
